
function fakeSocket() {
    return {
        on: function() { return this; },
        once: function() { return this; },
        off: function() { return this; },
        write: function() { return true; },
        end: function() { return this; },
        destroy: function() { return this; },
        setTimeout: function() { return this; },
        setNoDelay: function() { return this; },
        setKeepAlive: function() { return this; },
    };
}
var netModule = {
    createConnection: function() { return fakeSocket(); },
    connect: function() { return fakeSocket(); },
    Socket: function() { return fakeSocket(); },
    Server: function() {},
    createServer: function() {
        return { listen: function() { return this; }, on: function() { return this; } };
    },
};
netModule.default = netModule;
module.exports = netModule;
